import React, { useCallback, useEffect } from 'react';
import { getSearchState } from '../../search/state/search-state';
import { useMyWorkoutsInfiniteQuery } from '../../../client/query/my-workouts';
import flatten from 'lodash.flatten';
import { setToolbarTitle } from '../../../store/to-native';
import InfiniteScroll from '../../../components/infinite-scroll';
import GridSection from '../../../components/grid-section';
import Loading from '@ifit/mp-loading';
import { myWorkoutsTitle } from '../../../i18n/translations';

export const MyWorkouts = () => {
  const { isLoading, data, fetchNextPage } = useMyWorkoutsInfiniteQuery();
  const fetchMore = useCallback(() => fetchNextPage(), [fetchNextPage]);
  useEffect(() => {
    getSearchState().setViewContext({});
    setToolbarTitle(myWorkoutsTitle());
  }, []);

  if (isLoading || !data?.pages) {
    return <Loading data-testid="loading-spinner" />;
  }

  const { pages } = data;
  const hasMoreItems = pages.length && pages[pages.length - 1].hasMoreItems;
  const myWorkouts = flatten(pages.map(p => p.data));

  return (
    <div className="my-workouts-view">
      {myWorkouts[0] && (
        <InfiniteScroll
          reset={pages.length === 1}
          loadMore={fetchMore}
          hasMoreItems={hasMoreItems}
          libraryCards={myWorkouts}
        >
          <GridSection />
        </InfiniteScroll>
      )}
    </div>
  );
};

export default MyWorkouts;
